<template>
  <div class="login_conter">
    <div class="login_box">
      <loginForm></loginForm>
    </div>
  </div>
</template>

<script>
import loginForm from '@/views/shopping/login/components/loginForm';

export default {
  name: "login",
  components: {
    loginForm
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.login_conter {
  width: 100%;
  min-height: 760px;

  .login_box {
    width: 100%;
    background: #4b6a8b url('../../../../assets/images/banner-sign.jpg') no-repeat center center;
    padding-top: 50px;
    padding-bottom: 60px;
    height: 544px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
